















































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue, Watch } from "vue-property-decorator";
import { storeSupervisiCssd } from "@/store/modules/SupervisiCssdStore";
import SupervisiCssdSvc from "@/services/SupervisiCssdService";
import { userModule } from "@/store/modules/user";
import { appModule } from "@/store/modules/app";
import CardModalTtd from "@/components/modal/CardModalTtd.vue";
import VCDateTimePicker from "@/components/form_components/VCDateTimePicker.vue";
import {
  composeDate,
  toDateString,
  toTimeString
} from "@/utils/asesmenIntensifDateTime";
import {
  SupervisiCssdKategori,
  KATEGORI_LABEL,
  KATEGORI_ORDER,
} from "@/types/SupervisiCssd";

@Component({ components: { CardModalTtd, VCDateTimePicker } })
export default class SupervisiCssdFormPage extends Vue {
  parent: any = {
    nomor_formulir: "",
    tanggal_supervisi: localISODate(),
    waktu_mulai: "",
    waktu_selesai: "",
    supervisor_jabatan: "",
    kepala_unit_nama_manual: "",
    temuan_utama: "",
    rencana_tindak_lanjut: "",
    kesimpulan: "",
  };
  itemsDraft: any[] = [];
  saving = false;
  showTtdModal = false;
  signRole: "supervisor" | "kepala-unit" = "supervisor";

  kategoriOrder: SupervisiCssdKategori[] = KATEGORI_ORDER;
  kategoriLabel = KATEGORI_LABEL;

  get routeId() {
    return this.$route.params.id;
  }

  get isNew() {
    return this.routeId === "baru";
  }

  get current() {
    return storeSupervisiCssd.currentItem;
  }

  get locked() {
    return !!(this.current && this.current.is_locked);
  }

  get hasLegacyIsian() {
    const c = this.current;
    return !!(c && (c.waktu_mulai || c.waktu_selesai || c.supervisor_jabatan || c.temuan_utama || c.rencana_tindak_lanjut));
  }

  get checklistRows() {
    const rows: any[] = [];
    let groupNo = 0;
    this.kategoriOrder.forEach(kategori => {
      const items = this.itemsByKategori(kategori);
      if (!items.length) return;
      groupNo += 1;
      items.forEach((item, idx) => {
        rows.push({
          item,
          groupNo,
          kegiatan: this.kategoriLabel[kategori],
          isFirst: idx === 0,
          groupSize: items.length,
          huruf: String.fromCharCode(97 + idx),
        });
      });
    });
    return rows;
  }

  get supervisorName() {
    if (this.current && this.current.supervisor) return this.current.supervisor.nama || "";
    return userModule.user?.nama || "";
  }

  async mounted() {
    if (!this.isNew) {
      await this.load();
    }
  }

  @Watch("$route.params.id")
  async onRouteIdChange(newId: string) {
    if (newId && newId !== "baru") {
      await this.load();
    }
  }

  async load() {
    await storeSupervisiCssd.refresh(Number(this.routeId));
    if (this.current) {
      this.parent = {
        nomor_formulir: this.current.nomor_formulir,
        tanggal_supervisi: this.current.tanggal_supervisi,
        waktu_mulai: this.trimTime(this.current.waktu_mulai) || "",
        waktu_selesai: this.trimTime(this.current.waktu_selesai) || "",
        supervisor_jabatan: this.current.supervisor_jabatan || "",
        kepala_unit_nama_manual: this.current.kepala_unit_nama_manual || "",
        temuan_utama: this.current.temuan_utama || "",
        rencana_tindak_lanjut: this.current.rencana_tindak_lanjut || "",
        kesimpulan: this.current.kesimpulan || "",
      };
      this.itemsDraft = (this.current.items || []).map(i => ({ ...i }));
    }
  }

  get tanggalSupervisiDate(): Date | null {
    return composeDate(this.parent.tanggal_supervisi);
  }
  set tanggalSupervisiDate(val: Date | null) {
    this.parent.tanggal_supervisi = toDateString(val) || "";
  }

  trimTime(v: string | null | undefined): string | null {
    if (!v) return null;
    const s = String(v).trim();
    return s.length >= 5 ? s.substring(0, 5) : null;
  }

  itemsByKategori(kategori: SupervisiCssdKategori) {
    return this.itemsDraft
      .filter(i => i.kategori === kategori)
      .sort((a, b) => a.urutan - b.urutan);
  }

  async saveNew() {
    this.saving = true;
    try {
      const payload: any = {
        tanggal_supervisi: this.parent.tanggal_supervisi,
        supervisor_user_id: userModule.user.id,
        kepala_unit_nama_manual: this.parent.kepala_unit_nama_manual || null,
      };
      const resp = await SupervisiCssdSvc.create(payload);
      const id = resp.data.data.id;
      this.$router.replace({ name: "supervisi-cssd-form", params: { id: String(id) } });
    } finally {
      this.saving = false;
    }
  }

  async saveDraft() {
    if (!this.current) return;
    this.saving = true;
    try {
      await SupervisiCssdSvc.update(this.current.id, {
        tanggal_supervisi: this.parent.tanggal_supervisi,
        kepala_unit_nama_manual: this.parent.kepala_unit_nama_manual || null,
        kesimpulan: this.parent.kesimpulan || null,
      });
      await SupervisiCssdSvc.updateItems(
        this.current.id,
        this.itemsDraft.map(i => ({
          id: i.id,
          hasil: i.hasil || null,
          masalah: i.masalah || null,
          rekomendasi: i.rekomendasi || null,
        }))
      );
      await this.load();
    } finally {
      this.saving = false;
    }
  }

  openSign(role: "supervisor" | "kepala-unit") {
    this.signRole = role;
    this.showTtdModal = true;
  }

  async onSignPassword(password: string) {
    if (!this.current) return;
    this.saving = true;
    try {
      if (!this.locked) {
        await this.saveDraft();
      }
      if (this.signRole === "supervisor") {
        await SupervisiCssdSvc.signSupervisor(this.current.id, { password });
      } else {
        if (!this.current.kepala_unit_user_id) {
          await SupervisiCssdSvc.update(this.current.id, {
            kepala_unit_user_id: userModule.user.id,
          });
        }
        await SupervisiCssdSvc.signKepalaUnit(this.current.id, { password });
      }
      appModule.addMsgTtd("");
      await this.load();
    } catch (e) {
      const msg = (e as any)?.response?.data?.message || "Gagal menandatangani";
      appModule.addMsgTtd(msg);
      this.showTtdModal = true;
    } finally {
      this.saving = false;
    }
  }

  printPdf() {
    if (this.current) SupervisiCssdSvc.printPdf(this.current.id);
  }

  back() {
    this.$router.push({ name: "supervisi-cssd-list" });
  }

  formatDt(dt?: string | null) {
    if (!dt) return "";
    const d = new Date(dt);
    const pad = (n: number) => String(n).padStart(2, "0");
    return `${pad(d.getDate())}-${pad(d.getMonth() + 1)}-${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
  }
}
